import { AccommodationsSearchRequestDto } from '@/features/AccommodationList/api/requestTypes';
import { atom } from 'jotai';

export enum MessageStatus {
  New = 'N',
  Calculating = 'C',
  Sent = 'S',
  Received = 'R',
  ProcessedOnClient = 'P'
}

export interface IMessage {
  localId?: string;
  id?: string;
  message?: string;
  query?: string;
  isUserMessage: boolean;
  status: MessageStatus;
  type?: 'no-results-suggestions';
  contextRequest?: { searchRequest?: AccommodationsSearchRequestDto };
}

type ChatMessages = {
  chatId: string;
  messages: IMessage[];
};

export const getNewChatId = () => uuidv4();

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}


export const chatMessagesAtom = atom<ChatMessages>({
  chatId: getNewChatId(),
  messages: []
});
